import styled from 'styled-components';

export const Line = styled.div`
  background: linear-gradient(90deg, #0097f8 0%, #00f0ff 100%), #ffffff;
  color: var(--theme-colors-secondary);
  height: var(--line-height);
  padding: 0 16px;
  display: flex;
  align-items: center;
`;
